import { render, staticRenderFns } from "./CsvImport.vue?vue&type=template&id=22d6b896&scoped=true"
import script from "./CsvImport.vue?vue&type=script&lang=js"
export * from "./CsvImport.vue?vue&type=script&lang=js"
import style0 from "./CsvImport.vue?vue&type=style&index=0&id=22d6b896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6b896",
  null
  
)

export default component.exports